import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";
import VerticalRegistry from "../constants/verticalRegistry";
import { normalizeSearchUserResponse } from "../adapters/searchUserAdapter";

export const searchUser = async ({ vertical, searchParams }) => {
  const verticalInfo = VerticalRegistry.getVerticalByName(vertical);

  const { endpoint, options } = verticalInfo.buildSearchRequest(searchParams);
  const response = await fetchJSON(endpoint, options);

  return normalizeSearchUserResponse(response, verticalInfo);
};

export const useSearchUser = () => useMutation({ mutationFn: searchUser });
